(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSelectSignInProfile(
    $http, $timeout, GoProfilePaging, GoProfileService, toastr, $filter, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        vendorPrinters: "=vendorPrinters",
        singlePrinter: '=singlePrinter',
        goSupportedPrinters: "=goSupportedPrinters",
        editMode: '=editMode',
        vendor: '=vendor',
        stagePrinters: '&stagePrinters',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerList/selectSignInProfile/selectSignInProfile.template.html',
      link: function(scope) {
        // scope.validPrinters = scope.goSupportedPrinters.filter((printer) => !printer.info.problems)
        scope.paginationObject = new GoProfilePaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';
        scope.selectedItem = null;

        scope.selectMode = angular.copy(scope.editMode);
        scope.printersCount = 0;

        scope.applyTo = {
          all: false
        };

        (function() {
          filterDonePrinters();
          getFirstPage();
        })();

        function filterDonePrinters () {
          switch (scope.selectMode) {
            case 'VENDOR':
              scope.printersCount = scope.vendorPrinters.filter(printer => printer.info.install.progression !== 'DONE' && !printer.info.problems)
            break;
            case 'ALL':
              scope.printersCount = scope.goSupportedPrinters.filter(printer => printer.info.install.progression !== 'DONE' && !printer.info.problems)
            break;
          }
        }

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Pagination stuff
        ////////////////////////////////////
        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;
          GoProfileService.getGoProfilePaged(scope.paginationObject).then(function(printerSignInProfiles) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = printerSignInProfiles.page.totalPages;
            if (printerSignInProfiles.list) {
              scope.list = printerSignInProfiles.list;
            }
          }).catch( function(error) {});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            GoProfileService.getGoProfilePaged(scope.paginationObject).then(function(printerSignInProfiles){
              if (printerSignInProfiles.list) {
                scope.list = scope.list.concat(printerSignInProfiles.list);
              }
              scope.loadingPage = false;
            }).catch( function(error) {})
          }
        }

        angular.element('.item-list-nested').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 5;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.item-list-nested').off('scroll');
        });


        ////////////////////////////////////
        ////////////////////////////////////
        //////  Select & Save on printer
        ////////////////////////////////////

        scope.changeEditMode = function () {
          if (scope.applyTo.all) {
            scope.selectMode = 'ALL'
          } else {
            scope.selectMode = scope.editMode;
          }
          filterDonePrinters();
        }

        scope.selectSignInProfile = function (item) {
          scope.selectedItem = item;
        }

        scope.closeList = function () {
          scope.selectedItem = null;
          scope.callback()
        }

        scope.stageItemOnPrinters = function () {

          switch (scope.selectMode) {
            case 'SINGLE':
              const printerIndex = findPrinterIndex(scope.singlePrinter.info._links.self.href);
              setItemOnPrinter(scope.goSupportedPrinters[printerIndex]);
            break;
            case 'VENDOR':
              angular.forEach(scope.vendorPrinters, (printer) => {
                const printerIndex = findPrinterIndex(printer.info._links.self.href);
                setItemOnPrinter(scope.goSupportedPrinters[printerIndex]);
              })
            break;
            case 'ALL':
              angular.forEach(scope.goSupportedPrinters, (printer) => {
                setItemOnPrinter(printer);
              })
            break;
          }
          scope.stagePrinters({printers: scope.goSupportedPrinters, vendor: scope.vendor, editMode: scope.selectMode})
          $rootScope.$broadcast('ADD_CREDENTIAL', {credential: scope.selectedItem});
        }

        function findPrinterIndex (printerID) {
          const foundIndex = scope.goSupportedPrinters.findIndex(printer => printer.info._links.self.href === printerID);
          return foundIndex;
        }

        function setItemOnPrinter (printer) {
          const problems = printer.info.problems;
          const progression = printer.info.install.progression;
          const state = printer.info.install.state;
          if (!problems && progression !== 'DONE' && !state.IN_PROGRESS) {
            printer.info.install.signInProfile = scope.selectedItem;
            printer.info.install.resetProcess();
          } else if (problems && !problems.OFFLINE && progression !== 'DONE' && !state.IN_PROGRESS) {
            printer.info.install.signInProfile = scope.selectedItem;
            printer.info.install.resetProcess();
          }
        }


      }
    };
  }

  pxSelectSignInProfile.$inject = [
    '$http', '$timeout', 'GoProfilePaging', 'GoProfileService', 'toastr', '$filter', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxSelectSignInProfile', pxSelectSignInProfile);

})();
